import type { AxiosError, AxiosRequestConfig } from 'axios';
import axiosInstance from '@/lib/axiosInstance';

/**
 * Custom orval mutator wrapping the project's axiosInstance.
 * Unwraps response.data so generated functions return typed payloads directly.
 * Preserves Firebase token injection and withCredentials from axiosInstance.
 */
export const customInstance = <T>(config: AxiosRequestConfig, options?: AxiosRequestConfig): Promise<T> => {
  return axiosInstance({
    ...config,
    ...options,
  }).then(({ data }) => data);
};

export type ErrorType<Error> = AxiosError<Error>;
export type BodyType<BodyData> = BodyData;
